import ChargeHelper from 'features/Charge/chargeHelper';
import FleetHelper, { FleetConstants } from 'features/Fleet/fleetHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogSetDriverChargingPriceView.propTypes = {
    driverDetail: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogSetDriverChargingPriceView({ driverDetail, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(FleetConstants.PaymentMethod.FLEET);
    const [creditLimitPeriod, setCreditLimitPeriod] = useState('');
    const [creditLimit, setCreditLimit] = useState('');

    useEffect(() => {
        if (driverDetail) {
            setPaymentMethod(driverDetail?.driver?.paymentMethod);
            setCreditLimitPeriod(driverDetail?.driver?.creditLimitPeriod);
            setCreditLimit(driverDetail?.driver?.creditLimit);
        }
    }, [driverDetail]);

    // MARK: ---- METHODS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (!Utils.isValid) {
            ToastHelper.showError('Vui lòng điền đủ thông tin bắt buộc');
            return;
        }
        if (Utils.isValid(creditLimit)) {
            if (creditLimit <= 0) {
                ToastHelper.showError('Hạn mức phải lớn hơn 0');
                return;
            }
        }
        setLoading(true);
        const res = await ChargeHelper.API.Driver.requestUpdateDriver(
            driverDetail?.userId,
            {
                paymentMethod,
                creditLimitPeriod,
                creditLimit,
            }
        );
        if (_.isBoolean(res) && res) {
            ToastHelper.showSuccess('Đặt chính sách thanh toán phí sạc thành công');
            if (onDone) {
                onDone();
            }
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2">
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Loại chính sách', true)}
                        <KTBSDropdown
                            toggleElement={({ showError }) => (
                                <button
                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                    type="button"
                                >
                                    {_.find(
                                        FleetHelper.Data.DriverChargingTypeOptions,
                                        (item) => item.value === paymentMethod
                                    )?.name ?? 'Chọn loại chính sách'}
                                </button>
                            )}
                            selectedValue={paymentMethod}
                            dropdownMenuItems={FleetHelper.Data.DriverChargingTypeOptions}
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            dropdownMenuClassName="overflow-auto w-100"
                            onChange={(value) => setPaymentMethod(value)}
                            enableCheckValid
                            isDropdownForm={true}
                        />
                    </div>
                </div>
                <div className="col-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Kỳ hạn áp dụng')}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                type="button"
                            >
                                {creditLimitPeriod ? FleetHelper.Utils.getCreditLimitPeriodName(creditLimitPeriod) : 'Chọn kỳ hạn áp dụng'}
                            </button>
                        )}
                        selectedValue={creditLimitPeriod}
                        dropdownMenuItems={FleetHelper.Data.creditLimitPeriodOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => {
                            setCreditLimitPeriod(value);
                        }}
                        enableCheckValid
                        // isValid={Utils.isValid(creditLimitPeriod)}
                        isTouched={readyToValidate}
                        feedbackText="Kỳ hạn áp dụng không hợp lệ"
                        isDropdownForm={true}
                    />
                </div>
                <div className="col-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Hạn mức')}
                    <KTFormInput
                        type={KTFormInputType.currency}
                        placeholder="Nhập hạn mức"
                        name="creditLimit"
                        value={creditLimit}
                        onChange={(value) => {
                            setCreditLimit(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={!Utils.isValid(creditLimit) || Utils.isValid(creditLimit) && creditLimit >= 0}
                        isTouched={readyToValidate}
                        feedbackText="Hạn mức không hợp lệ"
                    />
                </div>
            </div>

            {/* footer */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
                {UIHelper.buildGreenButton('Xác nhận', handleSubmit, null, true, loading)}
            </div>
        </div>
    );
}

export default DialogSetDriverChargingPriceView;
